import { Components, Theme } from "@mui/material";

export const MuiInput: Components<Theme>["MuiInput"] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        ...theme.typography.formInput,
        lineHeight: "2.75rem",
        padding: ".875rem",
        paddingTop: ".5rem",
        paddingBottom: ".5rem",
        columnGap: ".5rem",
        marginTop: ".75rem",
        textTransform: "none",
        background: "#fff",
        border: "1px solid #D7DEF8",
        borderRadius: ".75rem",
      };
    },
  },
};
